import type { UI } from '@/v2/types';

import InclusionsList from '@/v2/components/ui/Inclusions';

export type InclusionsProps = {
  offer: UI.RoomOptionOffer;
};

const DEFAULT_INCLUSION_COUNT = 4;

const Inclusions = ({ offer }: InclusionsProps) => {
  const { hotelOffer, leadInOffer } = offer;
  const isLeadInOffer = !!leadInOffer;
  const inclusions = isLeadInOffer
    ? leadInOffer?.inclusions
    : hotelOffer?.inclusions;

  const isExpandable =
    !isLeadInOffer && inclusions?.length > DEFAULT_INCLUSION_COUNT;

  return (
    <InclusionsList
      inclusions={inclusions}
      numberToShow={DEFAULT_INCLUSION_COUNT}
      includeAndMoreText={isLeadInOffer}
      isExpandable={isExpandable}
    />
  );
};

export default Inclusions;
